import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'
import { FC, SyntheticEvent, useEffect, useState } from 'react'
import { useTankInfoStageStore } from '../../../store/tankInfo/useTankInfoStageStore'
import { CardNameLiteral } from '../../../types/apiResponse/tankInfoSettingTypes'

export type ToggleButtonProps = {
  cardName: CardNameLiteral
  isToggled: boolean
  cardType: string
  onTypeChange: (newCardType: string) => void
  possibleKeys: string[]
}

export const ToggleButton: FC<ToggleButtonProps> = ({
  cardName,
  isToggled,
  cardType,
  onTypeChange,
  possibleKeys,
}) => {
  const [selectedKey, setSelectedKey] = useState<string>(!isToggled ? 'off' : cardType)
  const { editToggle, editType } = useTankInfoStageStore()

  // Sync selectedKey with props when they change
  useEffect(() => {
    setSelectedKey(!isToggled ? 'off' : cardType)
  }, [isToggled, cardType])
  const onSelectDropDownItem = (e: SyntheticEvent<HTMLButtonElement>, key: string) => {
    e.preventDefault()
    e.stopPropagation()
    onTypeChange(key)
    // Handle toggle state changes
    switch (key) {
      case 'on':
        editToggle(cardName, true)
        // When turning on without specific type, keep the previous type
        break
      case 'off':
        editToggle(cardName, false)
        break
      case 'gauge':
        editToggle(cardName, true) // Automatically turn on when selecting a type
        editType(cardName, 'gauge')
        break
      case 'spec':
        editToggle(cardName, true) // Automatically turn on when selecting a type
        editType(cardName, 'spec')
        break
      case 'graph':
        editToggle(cardName, true) // Automatically turn on when selecting a type
        editType(cardName, 'graph')
        break
      case 'distribution':
        editToggle(cardName, true) // Automatically turn on when selecting a type
        editType(cardName, 'distribution')
        break
    }
    setSelectedKey(key)
  }

  const convertSelectedKey = (key: string) => {
    switch (key) {
      case 'on':
        return 'ON'
      case 'off':
        return 'OFF'
      case 'gauge':
        return 'Gauge'
      case 'spec':
        return 'Specification'
      case 'graph':
        return 'Graph'
      case 'distribution':
        return 'Distribution'
    }
  }

  return (
    <Menu preventOverflow={true}>
      <MenuButton
        as={Button}
        size="xs"
        width="120px"
        height="30px"
        mb={1}
        variant="bordered"
        className={`${selectedKey !== 'off' ? 'bg-white' : 'bg-tdpllightgrey'} 
                    border-tdpldarkgrey border-1 border-opacity-60`}
      >
        <p className="font-normal text-tdplindigo text-[0.875rem] md:text-[1rem]">
          {convertSelectedKey(selectedKey)}
        </p>
      </MenuButton>
      <MenuList
        aria-label={`${cardName}-setting-panel`}
        minWidth="120px"
        width="120px"
        className="bg-white border-tdpldarkgrey border-1 border-opacity-60"
      >
        {possibleKeys.map((key) => {
          return (
            <MenuItem
              key={key}
              aria-labelledby={`${cardName}-setting-panel`}
              onClick={(e) => onSelectDropDownItem(e, key)}
              className="w-full text-center justify-center font-normal text-tdplindigo text-[0.875rem] md:text-[1rem]"
              style={{
                padding: '8px 16px',
                margin: '0',
                textAlign: 'center',
                justifyContent: 'center',
              }}
            >
              {convertSelectedKey(key)}
            </MenuItem>
          )
        })}
      </MenuList>
    </Menu>
  )
}
